import { render } from "./RestablecerContrasenaForm.vue?vue&type=template&id=deb7094e&scoped=true"
import script from "./RestablecerContrasenaForm.vue?vue&type=script&lang=js"
export * from "./RestablecerContrasenaForm.vue?vue&type=script&lang=js"

import "./RestablecerContrasenaForm.vue?vue&type=style&index=0&id=deb7094e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deb7094e"]])

export default __exports__